// src/payment/components/PaymentSummary.js
import React from 'react';
import PropTypes from 'prop-types';
import './PaymentSummary.css';

const PaymentSummary = ({ resumen, compact = false }) => {
  if (!resumen) return null;

  const pkg = resumen.paqueteSeleccionado;
  const campos = resumen.camposActivos || [];
  
  const nombre = campos.find(c => 
    c.nombre?.toLowerCase().includes('nombre')
  )?.valor || '';

  const apellido = campos.find(c => 
    c.nombre?.toLowerCase().includes('apellido')
  )?.valor || '';

  const nombreCompleto = apellido ? `${nombre} ${apellido}` : nombre;

  // Calcular número de competidores
  const numCompetidores = parseInt(pkg?.number_of_competitors) || 1;
  let tipoEquipo = 'Individual';
  if (numCompetidores === 2) tipoEquipo = 'Dupla';
  else if (numCompetidores === 3) tipoEquipo = 'Trio';
  else if (numCompetidores > 3) tipoEquipo = `Equipo de ${numCompetidores}`;

  // Valores de montos y fees
  const moneda = pkg?.currency || 'Bs.';
  // 🟢 FIX: `resumen.monto` es siempre el precio BASE puro (el backend lo
  // valida así, sin fee). Antes se usaba `resumen.montoBase` como fallback,
  // pero ese campo ya no existe — ahora `monto` mismo ES la base.
  const montoBase = parseFloat(resumen.monto || pkg?.amount || 0);
  const feeAplicado = parseFloat(resumen.feeAplicado || 0);
  const tieneFee = feeAplicado > 0;
  // 🟢 FIX: el Total ahora prioriza `montoConFee` (base + fee, calculado en
  // PaymentModal para mostrar) y cae a `monto` si todavía no cargó el fee.
  // Antes mostraba `resumen.monto` crudo (sin parseFloat/toFixed), que
  // nunca iba a incluir el fee porque `monto` es y debe seguir siendo el
  // precio base puro que valida el backend.
  const montoTotal = parseFloat(resumen.montoConFee ?? resumen.monto ?? 0);

  return (
    <div className={`payment-summary ${compact ? 'compact' : ''}`}>
      <div className="summary-item">
        <span className="summary-label">Paquete:</span>
        <span className="summary-value">{pkg?.title || 'Ninguno'}</span>
      </div>
      
      {nombreCompleto && (
        <div className="summary-item">
          <span className="summary-label">Participante:</span>
          <span className="summary-value">{nombreCompleto}</span>
        </div>
      )}

      <div className="summary-item">
        <span className="summary-label">Tipo:</span>
        <span className="summary-value">{tipoEquipo}</span>
      </div>

      {/* Si hay fee, mostramos el desglose del Subtotal y Tasa */}
      {tieneFee && (
        <>
          <div className="summary-item">
            <span className="summary-label">Monto Inscripción:</span>
            <span className="summary-value">{montoBase.toFixed(2)} {moneda}</span>
          </div>
          <div className="summary-item">
            <span className="summary-label">Tasa de transacción:</span>
            <span className="summary-value">+{feeAplicado.toFixed(2)} {moneda}</span>
          </div>
        </>
      )}

      {/* Total Final */}
      <div className="summary-item highlight">
        <span className="summary-label">Total:</span>
        <span className="summary-value">
          {montoTotal.toFixed(2)} {moneda}
        </span>
      </div>
    </div>
  );
};

PaymentSummary.propTypes = {
  resumen: PropTypes.shape({
    monto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    montoConFee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    feeAplicado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paqueteSeleccionado: PropTypes.shape({
      title: PropTypes.string,
      currency: PropTypes.string,
      amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      number_of_competitors: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    camposActivos: PropTypes.arrayOf(
      PropTypes.shape({
        nombre: PropTypes.string,
        valor: PropTypes.any,
      })
    ),
  }),
  compact: PropTypes.bool,
};

export default PaymentSummary;
